import ngStorage from '../../../common/wrappers/ngstorage';
import _ from 'lodash';

import Selector, {selectorTpl, REQUIRED_IMPORTS} from './selector/selector.component';

import City from '../models/city.model';
import cityRes from '../resources/city.resource';

import geolocationModule, {GEOLOCATION_REQUESTED_EVENT} from '../location/geolocation.service';

import './city-advanced-selector.scss';

const NEARBY_CITIES_SELECTION = Symbol("city_locations_selection");
const DEFAULT_INDEX = 0;

class CityAdvancedSelectorComponent extends Selector {
  constructor($scope, $q, $timeout, $sessionStorage, $log, gettextCatalog,
              CityResource, GeolocationService) {
    'ngInject';
    super(gettextCatalog.getString('Kaupunki'));
    this.$sessionStorage = $sessionStorage;

    this.$log = $log;
    this.gettextCatalog = gettextCatalog;
    this.GeolocationService = GeolocationService;
    this.CityResource = CityResource

    /**
     * Callback to call when a location is selected.
     * @type {Function}
     */
    this.selectCityCallback = null;

    /**
     * Callback to call when nearby is selected.
     * @type {Function}
     */
    this.selectNearbyCallback = null;

    this.loaded = false;

    this.$q = $q;

    this.$timeout = $timeout;

    // If geolocation is requested elsewhere, make the selection in here as well.
    $scope.$on(GEOLOCATION_REQUESTED_EVENT, () => this._selectNearby());

    this.nearbySelection = {
      label: this.gettextCatalog.getString('Paikanna minut'),
      obj: NEARBY_CITIES_SELECTION, class: 'oral-location-nearby'
    };

    this.menuId = 'city-advanced-selector-menu';
  }

  loadData() {
    return this.CityResource.getAll()
      .then(data => {
        let result = data.list
          .filter(city => this.idFilter == null || this.idFilter.includes(city.id))
          .map(city => {
            return { label: city.name, obj: city };
          });

        result = _.sortBy(result, ['label']);

        this.nearbySelection.class += this.showNearby ? '' : ' hidden';
        result.unshift(this.nearbySelection);

        return result;
    });
  }

  $onChanges(changesObj) {
    this.object = null;
    super.$onChanges();

    // If empty object is set
    if ('selection' in changesObj && changesObj.selection.currentValue != null && _.isEmpty(changesObj.selection.currentValue)) {
      this.$log.debug("Setting city advanced selector to empty value, saved value to default");
      this.$sessionStorage.citySelector = DEFAULT_INDEX;
    }

    if (this.extraClasses === null) {
      this.extraClasses = "";
    }
  }

  onPostInit() {
    // Select the previous selection the user had selected when loading the page
    this.object = !isNaN(this.$sessionStorage.citySelector) && this.objs.length > this.$sessionStorage.citySelector ?
      this.objs[this.$sessionStorage.citySelector] :
      this.objs.find(obj => obj.obj.is_default);

    this._setObject();

    if (this.object != null) {
      // Trigger select after super has processed return value
     this.$timeout(() => this.onSelect());
    }

    this.loaded = true;
  }

  onSelect() {
    super.onSelect();

    if (this.object) {
      if (this.object.obj === NEARBY_CITIES_SELECTION) {
        if (!this.showNearby) {
          this.nearbySelection.class += this.showNearby ? '' : ' hidden';

          this.object = this.objs.find(obj => obj.obj.is_default);
          this._setObject();
        }
        else {
          this.loading = true;
          this.selectNearbyCallback();
          this.loading = false;
        }

      }
      if (this.object.obj instanceof City) {
        this.selectCityCallback({ selection: this.object });
      }

      this.$sessionStorage.citySelector = Math.max(0, this.objs.indexOf(this.object));
    }
  }

  _selectNearby() {
    this.object = this.nearbySelection;
    this._setObject();
    this.onSelect();
  }

}

const config = {
  templateUrl: selectorTpl,
  controller: CityAdvancedSelectorComponent,
  bindings: {
    selection: '<',
    showNearby: '<',
    selectCityCallback: '&',
    selectNearbyCallback: '&',
    extraClasses: '@?'
  }
};

const mod = angular.module('app.component.cityAdvancedSelector',
  _.union(REQUIRED_IMPORTS, [
    ngStorage, cityRes, geolocationModule
  ]))

.component('cityAdvancedSelector', config)

;

export default mod.name;
